import * as $ from "jquery";
import { Requester } from "../common/requester";
import { Urls } from "../common/urls";

export async function sendOneSignalSubscriptionToBackend(subscriptionId: string)
{
    try
    {
        await Requester.get(Urls.RegisterOneSignalUserSubscriptionId, { id: subscriptionId });
    }
    catch (error)
    {
        console.error("Failed to register OneSignal user subscription ID:", error);
    }
}
